/* ============================================================
   Cupido's Drops — PDP JS (loaded only by sections/pdp-hero)
   gallery · reviews carousel · tabs · variant sync · ATC fetch
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Shared: current variant state ---------- */
  function currentVariant() {
    if (window.pdpSelectedVariant && window.pdpSelectedVariant.id) {
      return window.pdpSelectedVariant;
    }
    var checked = document.querySelector('[data-pdp-variant-input]:checked');
    if (checked) {
      return {
        id: checked.value,
        price: checked.dataset.price || '',
        compare: checked.dataset.compare || ''
      };
    }
    var hidden = document.querySelector('[data-pdp-variant-id]');
    return hidden ? { id: hidden.value, price: '', compare: '' } : null;
  }

  function updatePriceTargets(detail) {
    document.querySelectorAll('[data-pdp-atc-price], [data-pdp-sticky-price]').forEach(function (el) {
      el.textContent = detail.price;
    });
    document.querySelectorAll('[data-pdp-atc-compare], [data-pdp-sticky-compare]').forEach(function (el) {
      if (detail.compare) {
        el.textContent = detail.compare;
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    var hiddenId = document.querySelector('[data-pdp-variant-id]');
    if (hiddenId) hiddenId.value = detail.id;
  }

  /* ---------- Shared: add to cart (sticky bar path — the hero form
     submit is intercepted globally by cupido-cart.js) ---------- */
  function addToCart(variantId, button, subscribeChecked) {
    if (!variantId) return;
    var form = document.querySelector('[data-pdp-atc-form]');
    var addUrl = (form && form.dataset.cartAddJsUrl) || '/cart/add.js';
    var cartUrl = (form && form.dataset.cartUrl) || '/cart';
    var props = {};
    if (subscribeChecked) {
      props['Automatic refills'] = 'Save 25% — every 4 weeks, cancel anytime';
    }
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: props }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        /* "✓ Added" state on the sticky button for 1.5s, then the cart drawer opens */
        var stickyLabel = document.querySelector('[data-pdp-sticky-label]');
        var stickyPrices = document.querySelector('[data-pdp-sticky-prices]');
        var stickyBtn = document.querySelector('[data-pdp-sticky-submit]');
        if (stickyBtn) {
          stickyBtn.classList.add('is-added');
          stickyBtn.disabled = true;
        }
        if (stickyLabel) {
          if (stickyLabel.dataset.orig === undefined) stickyLabel.dataset.orig = stickyLabel.textContent;
          stickyLabel.textContent = '✓ Added';
        }
        if (stickyPrices) stickyPrices.hidden = true;
        setTimeout(function () {
          if (stickyLabel) stickyLabel.textContent = stickyLabel.dataset.orig;
          if (stickyPrices) stickyPrices.hidden = false;
          if (stickyBtn) {
            stickyBtn.classList.remove('is-added');
            stickyBtn.classList.remove('is-loading');
            stickyBtn.disabled = false;
          }
        }, 1500);
        if (window.CupidoCart) {
          window.CupidoCart.refresh().then(function () {
            window.CupidoCart.open();
          });
        } else {
          window.location.href = cartUrl;
        }
      })
      .catch(function () {
        /* Fallback: native form POST if fetch fails */
        if (form) {
          HTMLFormElement.prototype.submit.call(form);
        } else if (button) {
          button.disabled = false;
          button.classList.remove('is-loading');
        }
      });
  }

  /* ---------- Hero: variant radios ----------
     (the ATC form submit is handled by cupido-cart.js) ---------- */

  var variantInputs = document.querySelectorAll('[data-pdp-variant-input]');
  if (variantInputs.length) {
    variantInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var detail = {
          id: input.value,
          price: input.dataset.price || '',
          compare: input.dataset.compare || ''
        };
        window.pdpSelectedVariant = detail;
        updatePriceTargets(detail);
        document.dispatchEvent(new CustomEvent('pdp:variant-changed', { detail: detail }));
      });
    });
    /* Initialize shared state from the preselected bundle */
    var initial = currentVariant();
    if (initial && initial.price) {
      window.pdpSelectedVariant = initial;
      updatePriceTargets(initial);
    }
  }

  /* ---------- Sticky ATC bar ---------- */
  var sticky = document.querySelector('[data-pdp-sticky]');
  if (sticky) {
    var heroSection = document.querySelector('[data-pdp-hero-section]');
    if (heroSection && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
        },
        { threshold: 0 }
      ).observe(heroSection);
    } else {
      var onStickyScroll = function () {
        sticky.classList.toggle('is-visible', window.scrollY > window.innerHeight);
      };
      onStickyScroll();
      window.addEventListener('scroll', onStickyScroll, { passive: true });
    }

    var stickyBtn = sticky.querySelector('[data-pdp-sticky-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var variant = currentVariant();
        var subscribe = document.querySelector('[data-pdp-subscribe]');
        addToCart(variant && variant.id, stickyBtn, subscribe && subscribe.checked);
      });
    }
  }

  /* ---------- Hero gallery (scroll-snap carousel) ---------- */
  var gallery = document.querySelector('[data-pdp-gallery]');
  if (gallery) {
    var stage = gallery.querySelector('[data-pdp-stage]');
    var thumbs = gallery.querySelectorAll('[data-pdp-thumb]');
    var prev = gallery.querySelector('[data-pdp-prev]');
    var next = gallery.querySelector('[data-pdp-next]');

    if (stage && stage.querySelectorAll('[data-pdp-slide]').length > 1) {
      var slideCount = stage.querySelectorAll('[data-pdp-slide]').length;

      var goTo = function (index) {
        var clamped = Math.max(0, Math.min(index, slideCount - 1));
        stage.scrollTo({ left: clamped * stage.clientWidth, behavior: 'smooth' });
      };

      var activeIndex = function () {
        return Math.round(stage.scrollLeft / stage.clientWidth);
      };

      if (prev) prev.addEventListener('click', function () { goTo(activeIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(activeIndex() + 1); });

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goTo(Number(thumb.dataset.index));
        });
      });

      var syncThumbs = function () {
        var idx = activeIndex();
        thumbs.forEach(function (thumb) {
          thumb.classList.toggle('is-active', Number(thumb.dataset.index) === idx);
        });
      };
      stage.addEventListener('scroll', function () {
        window.requestAnimationFrame(syncThumbs);
      }, { passive: true });
    } else {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
    }
  }

  /* ---------- Reviews carousel ---------- */
  var reviews = document.querySelector('[data-pdp-reviews]');
  if (reviews) {
    var track = reviews.querySelector('[data-pdp-reviews-track]');
    var dotsWrap = reviews.querySelector('[data-pdp-reviews-dots]');
    var rPrev = reviews.querySelector('[data-pdp-reviews-prev]');
    var rNext = reviews.querySelector('[data-pdp-reviews-next]');

    if (track) {
      var pageCount = function () {
        return Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth));
      };
      var currentPage = function () {
        return Math.max(0, Math.min(Math.round(track.scrollLeft / track.clientWidth), pageCount() - 1));
      };
      var goToPage = function (page) {
        var clamped = Math.max(0, Math.min(page, pageCount() - 1));
        track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
      };

      var dots = [];
      if (dotsWrap) {
        for (var i = 0; i < pageCount(); i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'pdp-reviews__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Reviews page ' + (i + 1));
          dot.dataset.page = String(i);
          dotsWrap.appendChild(dot);
          dots.push(dot);
        }
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            goToPage(Number(dot.dataset.page));
          });
        });
      }

      var syncDots = function () {
        var page = currentPage();
        dots.forEach(function (dot) {
          dot.classList.toggle('is-active', Number(dot.dataset.page) === page);
        });
      };

      if (rPrev) rPrev.addEventListener('click', function () { goToPage(currentPage() - 1); });
      if (rNext) rNext.addEventListener('click', function () { goToPage(currentPage() + 1); });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(syncDots);
      }, { passive: true });

      window.addEventListener('resize', function () {
        goToPage(currentPage());
      });
    }
  }

  /* ---------- Problem tabs ---------- */
  var tabsRoot = document.querySelector('[data-pdp-tabs]');
  if (tabsRoot) {
    var tabs = tabsRoot.querySelectorAll('[data-pdp-tab]');
    var panels = tabsRoot.querySelectorAll('[data-pdp-tab-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.dataset.index;
        tabs.forEach(function (t) {
          var active = t.dataset.index === idx;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var active = panel.dataset.index === idx;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });
  }

  /* ---------- Timeline tabs + chart points ---------- */
  var timeline = document.querySelector('[data-pdp-timeline]');
  if (timeline) {
    var tTabs = timeline.querySelectorAll('[data-pdp-timeline-tab]');
    var points = timeline.querySelectorAll('[data-pdp-timeline-point]');
    tTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.dataset.index;
        tTabs.forEach(function (t) {
          var active = t.dataset.index === idx;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        points.forEach(function (point) {
          point.classList.toggle('is-active', point.dataset.index === idx);
        });
      });
    });
  }
})();
